<template>
    <ul id="importantDocs">
        <li v-for="(item, index) in items" :key="index">
            <a :href="item.FileURL" download>{{ item.Description }}</a>
        </li>
    </ul>
</template>

<script>
export default {
  name: "ImportantDocsTable",
  
  props: {
    items: Array
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
li
{
	vertical-align: bottom;
	text-align: left;
	margin-left: .75em;
  padding-bottom: .5em;
}
</style>
